<div class="row overide-header text-end m-auto">

  <div class="checklist" [formGroup]="sectionForm">
    <!-- Enhanced Header with Progress Bar -->
    <div class="checklist-header">
      <div class="header-left">
        <h4 class="checklist-title">Checklist</h4>
        @if (totalCount > 0) {
          <span class="completion-count">
            ({{completedCount}}/{{totalCount}} completed)
          </span>
        }
      </div>
      @if (totalCount > 0) {
        <div class="header-right">
          <div class="progress-bar-container">
            <div class="progress-bar-fill" [style.width.%]="completionPercentage"></div>
          </div>
        </div>
      }
    </div>

    @for (checklist of checklists().controls; track checklist; let i = $index) {
      <ng-container formArrayName="checklists">
        <div class="checklist-item-wrapper"
          [class.completed]="checklists().at(i)?.get('is_completed')?.value"
          [style.animation-delay.ms]="i * 50">
          <ng-container [formGroupName]="i">
            @if (checklists().at(i)?.get('edit_mode')?.value) {
              <div class="checklist-item-container">
                <div class="checkbox-wrapper">
                  <mat-checkbox
                    class="custom-checklist-checkbox bidone-checkbox"
                    formControlName="is_completed"
                    (change)="onChangeCheckbox($event)">
                  </mat-checkbox>
                </div>
                <div class="item-content-wrapper">
                  <div class="top-bar">
                    <div class="bar-tools" (mousedown)="onToolbarMouseDown($event)">
                      <div class="tool-item" (click)="openObserverParticipantPopup($event,CONST_OBSERVER_TYPE,i)">
                        <span class="tool-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="12px" viewBox="0 0 18 12" version="1.1">
                            <g transform="translate(-16, -11)" fill="#767C87" stroke="none" stroke-width="1" fill-rule="evenodd">
                              <path d="M24.9163797,11 C28.1668953,11 31.1155532,12.9244467 33.7623534,16.7733401 C33.8562279,16.9098494 33.8562281,17.0901027 33.7623538,17.2266122 L33.7623538,17.2266122 L33.5209255,17.5712272 C30.9365856,21.1904091 28.0684037,23 24.9163797,23 C21.6658641,23 18.7172062,21.0755533 16.070406,17.2266599 C15.9765315,17.0901506 15.9765313,16.9098973 16.0704056,16.7733878 L16.0704056,16.7733878 L16.3118339,16.4287728 C18.8961738,12.8095909 21.7643557,11 24.9163797,11 Z M24.9163797,14 C23.2595254,14 21.9163797,15.3431458 21.9163797,17 C21.9163797,18.6568542 23.2595254,20 24.9163797,20 C26.5732339,20 27.9163797,18.6568542 27.9163797,17 C27.9163797,15.3431458 26.5732339,14 24.9163797,14 Z" id="Combined-Shape"/>
                            </g>
                          </svg>
                        </span>
                        <span class="tool-name"> + Observer</span>
                      </div>
                      <div class="tool-item" (click)="openObserverParticipantPopup($event,CONST_PARTICIPANT_TYPE,i)">
                        <span class="tool-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19"><path fill="#828B95" d="M15.571 13.26c0-.602-.733-1.289-2.176-1.69a4.75 4.75 0 0 1-1.377-.672c-.093-.057-.079-.582-.079-.582l-.464-.076c0-.043-.04-.672-.04-.672.556-.201.499-1.384.499-1.384.353.21.583-.725.583-.725.417-1.3-.208-1.222-.208-1.222.11-.794.11-1.6 0-2.395-.278-2.633-4.466-1.918-3.97-1.058-1.224-.242-.944 2.746-.944 2.746l.265.774c-.521.363-.159.802-.14 1.307.025.746.45.591.45.591.026 1.23.592 1.391.592 1.391.106.773.04.642.04.642l-.503.065a2.3 2.3 0 0 1-.04.524c-.592.283-.72.45-1.308.726-1.136.534-2.37 1.229-2.59 2.165-.22.935-.3 2.285-.3 2.285h12.108l-.398-2.74z"/></svg>
                        </span>
                        <span class="tool-name"> + Participant</span>
                      </div>
                      @if (showMaterials) {
                        <div class="tool-item" (click)="openLineItemsPopup(i)">
                          <span class="tool-icon">
                            <mat-icon class="tool-mat-icon">inventory_2</mat-icon>
                          </span>
                          <span class="tool-name"> + Materials &amp; Services</span>
                        </div>
                      }
                      <div class="tool-item" (click)="isImportantCheckBox(i)">
                        <span class="tool-icon">
                          @if (checklists().at(i)?.get('is_important')?.value) {
                            <img style="width: 18px;" src="../../../../../assets/img/general_icons/color-fire.png" alt="fire icon">
                          }
                          @if (!checklists().at(i)?.get('is_important')?.value) {
                            <img style="width: 18px;" src="../../../../../assets/img/general_icons/light-fire.png" alt="fire icon">
                          }
                        </span>
                        <span class="tool-name">Important</span>
                      </div>
                      <div class="tool-item" (click)="removeCheckList(i)">
                        <span class="tool-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19"><path fill="#828B95" d="M9.31 3.794V2.697h2.182v1.097h2.862a1.5 1.5 0 0 1 1.5 1.5v.694H4.948v-.694a1.5 1.5 0 0 1 1.5-1.5H9.31zM6.04 7.085h8.724l-.791 8.962a1 1 0 0 1-.997.912H7.827a1 1 0 0 1-.996-.912l-.792-8.962h.001z"/></svg>
                        </span>
                        <span class="tool-name">  </span>
                      </div>
                    </div>
                  </div>
                  <input
                    type="text"
                    class="checklist-input"
                    [class.completed-text]="checklists().at(i)?.get('is_completed')?.value"
                    (keyup.enter)="ediViewChecklist(i,true)"
                    (blur)="onChecklistBlur(i)"
                    formControlName="text"
                    placeholder="Add checklist item">
                </div>
              </div>
              <div class="checklist-item-container users-row">
                <div class="checkbox-wrapper checkbox-spacer" aria-hidden="true">
                  <mat-checkbox class="custom-checklist-checkbox bidone-checkbox" [disabled]="true" tabindex="-1"></mat-checkbox>
                </div>
                <div class="item-users-wrapper">
                <div class="selected-users">
                  <div class="observer">
                    <mat-chip-listbox>
                      @for (user of checklists().at(i).get('observers')?.value; track user; let index = $index) {
                        <mat-chip-option>
                          <span class="mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="12px" viewBox="0 0 18 12" version="1.1">
                              <g transform="translate(-16, -11)" fill="#767C87" stroke="none" stroke-width="1" fill-rule="evenodd">
                                <path fill="#fff" d="M24.9163797,11 C28.1668953,11 31.1155532,12.9244467 33.7623534,16.7733401 C33.8562279,16.9098494 33.8562281,17.0901027 33.7623538,17.2266122 L33.7623538,17.2266122 L33.5209255,17.5712272 C30.9365856,21.1904091 28.0684037,23 24.9163797,23 C21.6658641,23 18.7172062,21.0755533 16.070406,17.2266599 C15.9765315,17.0901506 15.9765313,16.9098973 16.0704056,16.7733878 L16.0704056,16.7733878 L16.3118339,16.4287728 C18.8961738,12.8095909 21.7643557,11 24.9163797,11 Z M24.9163797,14 C23.2595254,14 21.9163797,15.3431458 21.9163797,17 C21.9163797,18.6568542 23.2595254,20 24.9163797,20 C26.5732339,20 27.9163797,18.6568542 27.9163797,17 C27.9163797,15.3431458 26.5732339,14 24.9163797,14 Z" id="Combined-Shape"/>
                              </g>
                            </svg>
                          </span>
                          <span [matTooltip]="getChipTypeLabel(user)">{{getChipNameUsingType(user)}}</span>
                          <span class="cursor-pointer ml-2" (click)="removeUsers(index,checklists().at(i).get('observers')?.getRawValue())"><img src="assets/img/cross_icon.svg" alt=""></span>
                        </mat-chip-option>
                      }
                      @for (user of checklists().at(i).get('participants')?.value; track user; let index = $index) {
                        <mat-chip-option>
                          <span class="mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19"><path fill="#fff" d="M15.571 13.26c0-.602-.733-1.289-2.176-1.69a4.75 4.75 0 0 1-1.377-.672c-.093-.057-.079-.582-.079-.582l-.464-.076c0-.043-.04-.672-.04-.672.556-.201.499-1.384.499-1.384.353.21.583-.725.583-.725.417-1.3-.208-1.222-.208-1.222.11-.794.11-1.6 0-2.395-.278-2.633-4.466-1.918-3.97-1.058-1.224-.242-.944 2.746-.944 2.746l.265.774c-.521.363-.159.802-.14 1.307.025.746.45.591.45.591.026 1.23.592 1.391.592 1.391.106.773.04.642.04.642l-.503.065a2.3 2.3 0 0 1-.04.524c-.592.283-.72.45-1.308.726-1.136.534-2.37 1.229-2.59 2.165-.22.935-.3 2.285-.3 2.285h12.108l-.398-2.74z"/></svg>
                          </span>
                          <span [matTooltip]="getChipTypeLabel(user)">{{getChipNameUsingType(user)}}</span>
                          <span class="cursor-pointer ml-2" (click)="removeUsers(index,checklists().at(i).get('participants')?.getRawValue())"><img src="assets/img/cross_icon.svg" alt=""></span>
                        </mat-chip-option>
                      }
                    </mat-chip-listbox>
                  </div>
                  @if (checklists().at(i).get('items')?.value?.length) {
                    <div class="line-items">
                      @for (item of checklists().at(i).get('items')?.value; track lineItemKey(item)) {
                        <span class="line-item-chip"
                          [matTooltip]="(item.kind === 'material' ? 'Material' : 'Service') + (item.vendor_name ? ' · ' + item.vendor_name : '')">
                          <mat-icon class="line-item-icon">{{ kindIcon(item) }}</mat-icon>
                          <span class="line-item-name">{{ item.item_name || '—' }}</span>
                          <span class="line-item-qty">× {{ item.quantity ?? '—' }}</span>
                          <button type="button" class="line-item-remove" [attr.aria-label]="'Unlink ' + item.item_name"
                            (mousedown)="onToolbarMouseDown($event)" (click)="removeLineItem(i, item)">
                            <mat-icon>close</mat-icon>
                          </button>
                        </span>
                      }
                    </div>
                  }
                  <!--<div class="participant">
                  <mat-chip-list>
                    <mat-chip *ngFor="let user of checklists().at(i).get('participants')?.value; let index=index">
                      <span class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19"><path fill="#fff" d="M15.571 13.26c0-.602-.733-1.289-2.176-1.69a4.75 4.75 0 0 1-1.377-.672c-.093-.057-.079-.582-.079-.582l-.464-.076c0-.043-.04-.672-.04-.672.556-.201.499-1.384.499-1.384.353.21.583-.725.583-.725.417-1.3-.208-1.222-.208-1.222.11-.794.11-1.6 0-2.395-.278-2.633-4.466-1.918-3.97-1.058-1.224-.242-.944 2.746-.944 2.746l.265.774c-.521.363-.159.802-.14 1.307.025.746.45.591.45.591.026 1.23.592 1.391.592 1.391.106.773.04.642.04.642l-.503.065a2.3 2.3 0 0 1-.04.524c-.592.283-.72.45-1.308.726-1.136.534-2.37 1.229-2.59 2.165-.22.935-.3 2.285-.3 2.285h12.108l-.398-2.74z"/></svg>
                      </span>
                      <span>{{user.full_name}}</span>
                      <span class="cursor-pointer ml-2"><img src="assets/img/cross_icon.svg" alt=""></span>
                    </mat-chip>
                  </mat-chip-list>
                </div>-->
              </div>
            </div>
            </div>
          }
          <!-- detail display checklist -->
          @if (checklists().at(i)?.get('view_mode')?.value == true) {
            <div class="checklist-item-container view-mode">
              <div class="checkbox-wrapper">
                <mat-checkbox
                  class="custom-checklist-checkbox bidone-checkbox"
                  formControlName="is_completed"
                  (change)="onChangeCheckbox($event)">
                </mat-checkbox>
              </div>
              <div class="item-content-wrapper">
                <div class="checklist-detail">
                  <div class="detail" (click)="ediViewChecklist(i,false,true)">
                    <p class="text serial-no">{{i+1}}.</p>
                    <p class="text" [class.completed-text]="checklists().at(i)?.get('is_completed')?.value">
                      {{checklists().at(i)?.get('text')?.value}}
                    </p>
                  </div>
                  @if (checklists().at(i)?.get('items')?.value?.length) {
                    <span class="checklist-items-badge" [matTooltip]="lineItemsSummary(i)">
                      <mat-icon>inventory_2</mat-icon>{{ checklists().at(i)?.get('items')?.value?.length }}
                    </span>
                  }
                  <div class="checklist-people">
                    @for (person of checklistPeople(i); track person.user?.id) {
                      <span class="checklist-avatar"
                        [style.background-color]="getAvatarColor(person)"
                        [matTooltip]="person.role + ': ' + person.user?.full_name">{{ getInitials(person.user?.full_name) }}</span>
                    }
                  </div>
                  <div class="remove delete-button">
                    <span class="tool-icon" (click)="removeCheckList(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 21 19">
                        <path fill="#ef4444" d="M9.31 3.794V2.697h2.182v1.097h2.862a1.5 1.5 0 0 1 1.5 1.5v.694H4.948v-.694a1.5 1.5 0 0 1 1.5-1.5H9.31zM6.04 7.085h8.724l-.791 8.962a1 1 0 0 1-.997.912H7.827a1 1 0 0 1-.996-.912l-.792-8.962h.001z"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }
        </ng-container>
      </div>
    </ng-container>
  }

  <!-- Empty State -->
  @if (totalCount === 0) {
    <div class="empty-state">
      <p class="empty-message">No checklist items yet</p>
    </div>
  }

  <!-- Enhanced Add Button -->
  <button type="button" class="add-checklist-button" (click)="addChecklist()">
    <svg class="plus-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
    <span>Add checklist item</span>
  </button>
</div>

</div>
